export const heroTags = [
  { label: 'Inventor', note: '3D-Konstruktion', side: 'left' },
  { label: 'AutoCAD', note: '2D-Zeichnungen', side: 'left' },
  { label: 'Blender', note: 'Animation', side: 'left' },
  { label: 'STEP · X_T', note: 'neutraler Austausch', side: 'right' },
  { label: 'DXF · DWG', note: 'Laser & Zeichnung', side: 'right' },
] as const;
